import { z } from "zod";

/** Query for `GET /v1/cede-arena/internal/payout-caps` (server token only). */
export const ArenaCampaignPayoutCapsQuerySchema = z.object({
  campaign: z.string().min(1),
});

export type ArenaCampaignPayoutCapsQueryDto = z.infer<typeof ArenaCampaignPayoutCapsQuerySchema>;

/**
 * Every seat of one arena competition whose payout a free-entry ticket caps (DEV-734), with the
 * cap in decimal USDT. A seat is listed exactly when `GET /me/campaign-stake` would quote that
 * player a non-null `maxWinUsdt`; empty while the payout cap is off.
 */
export const ArenaCampaignPayoutCapsDtoSchema = z.object({
  caps: z.array(
    z.object({
      hubUserId: z.number().int(),
      maxWinUsdt: z.string(),
    }),
  ),
});

export type ArenaCampaignPayoutCapsDto = z.infer<typeof ArenaCampaignPayoutCapsDtoSchema>;
